let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ejFK"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("3VpdY")]).then(() => parcelRequire('iqUA6'));